/**
 * 🟦 V11.5 — Share Recipe by URL.
 *
 * Serializa una receta → JSON → LZ-string (URL-safe base64) → URL completa.
 * Reversible 100%. Path: /share/recipe?data=...
 */
import LZString from 'lz-string';
import { buildPortableRecipe } from './exportRecipe';

const SHARE_PATH = '/share/recipe';
const MAX_PAYLOAD_LEN = 60_000; // límite de URL razonable para todos los browsers

/**
 * Genera la URL de share para una receta. Devuelve {ok, url?, error?}.
 */
export function buildShareUrl(recipe, origin) {
  const portable = buildPortableRecipe(recipe);
  if (!portable) return { ok: false, error: 'invalid_recipe' };
  const json = JSON.stringify(portable);
  const compressed = LZString.compressToEncodedURIComponent(json);
  if (!compressed || compressed.length > MAX_PAYLOAD_LEN) {
    return { ok: false, error: 'payload_too_large' };
  }
  const base = origin || (typeof window !== 'undefined' ? window.location.origin : '');
  return { ok: true, url: `${base}${SHARE_PATH}?data=${compressed}` };
}

/**
 * Decodifica un payload de share (string del query param `data`).
 * Devuelve {ok, portable?, error?}.
 */
export function decodeShareData(data) {
  if (!data || typeof data !== 'string') return { ok: false, error: 'missing_data' };
  try {
    const json = LZString.decompressFromEncodedURIComponent(data);
    if (!json) return { ok: false, error: 'decompression_failed' };
    const parsed = JSON.parse(json);
    return { ok: true, portable: parsed };
  } catch (e) {
    return { ok: false, error: 'invalid_payload' };
  }
}

/**
 * Copia la URL al clipboard. Devuelve Promise<boolean>.
 */
export async function copyShareUrlToClipboard(url) {
  if (!url || typeof navigator === 'undefined' || !navigator.clipboard) return false;
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
}
